<template>
  <div id="app">
    <div class="keyboard-containner" @click="dialogVisible = false" v-show="dialogVisible">
      <div :style="`position: absolute; top: ${dispH - 625 + headerHeight}px; width: 100%`">
        <iframe
          :src="keyboardHtml"
          style="marign-top: 20px"
          ref="iframe"
          frameborder="0"
          width="100%"
          height="700"
        ></iframe>
      </div>
    </div>
    <Login v-if="isLoginVisible" @login-success="loginSuccess"></Login>
    <div class="titlebar-container">
      <TitleBar
        v-show="!isLoginVisible"
        :currentPage="currentPage"
        :isEdittingVisible="isEdittingVisible"
        :isBackVisible="currentPage !== pages.patientmanager"
        @back-to-patientmanager="back2PatientManager"
        @show-settings="setSettingsVisible"
        @logout="logout"
        :isLoginVisible="isLoginVisible"
      />
    </div>
    <div
      class="titlebar-container"
      v-if="isMenuVisible && menuItems.length > 0"
      style="position: relative"
    >
      <Menu
        :isReCaputreVisible="currentPage === pages.capture"
        :menuItems="menuItems"
        :checktype="checkType"
        :currentKey="currentSubPage"
        :currentPage="currentPage"
        @select="selectSubPage"
      >
        <template #controls>
          <i
            class="iconfont icon-a-qingdanrenwujihua1"
            style="font-size: 50px"
            @click="delectSettingsVisible = true"
            v-if="
              currentPage === 'dryeye' ||
              currentPage === 'questionnaire' ||
              (currentPage === 'capture' &&
                currentSubPage !== 'topography' &&
                currentSubPage !== 'pupilcorneadia')
            "
          />
          <i
            class="iconfont icon-huaban14 capture-font"
            @click="showCapture(checkType, currentSubPage)"
            v-if="!isHasUrl && isReCaputreVisible && currentPage !== pages.capture"
          />
          <div
            v-if="
              currentPage === 'capture' &&
              currentSubPage.includes('pupilcorneadia') &&
              isNewInfrared
            "
            @click="enterRecordPupilCorneaDia"
            style="border: 1px solid gray; padding: 10px; font-size: 25px"
          >
            {{ $t("langcfg.txtViewResult") }}
          </div>
          <div
            style="font-size: 45px; font-weight: 600"
            @click="selectEyeType()"
            v-if="isReCaputreVisible"
          >
            {{ currentEye }}
          </div>
        </template>
      </Menu>

      <delect-settings :menuItems="menuItems" type="dryeye" :show.sync="delectSettingsVisible" />
    </div>
    <!--    <div class="wrapper-full" :style="`height:${mainHeight}px;`">-->
    <div class="wrapper-full" :style="`height:${mainHeight + 100}px;`">
      <div
        class="wrapper-full patient-manager"
        name="patient-record-list"
        v-show="isPatientManagerVisible"
        v-if="!isLoginVisible"
      >
        <div class="wrapper-patient-record" :style="`height:${mainHeight * 2}px`">
          <PatientList
            :patients="patients"
            :allPatientsCount="allPatientsCount"
            :isEdittingVisible="isEdittingVisible"
            :currentPatient="currentPatient"
            v-model="patientPage"
            :patientHeaders="patientHeaders"
            :language="focusLanguage"
            @add-patient="addPatient"
            @delete-patient="deletePatient"
            @search-patients="searchPatients"
            @change-page="changePage"
            @update-patient="updatePatient"
            @show-edit-patient="showEditPatient"
            @select-patient="selectPatient"
            @show-sort="showSort"
            @patient-page-changed="patientPageChanged"
            @load-pre-patients="loadPrePatients"
            @show-export="showExport"
          />
        </div>
        <div class="wrapper-patient-record border-left" :style="`height:${mainHeight + 100}px`">
          <RecordList
            :records="records"
            :isMaskVisible="isEdittingVisible"
            :currentRecord="currentRecord"
            :currentEye="currentEye"
            @show-capture="showCapture"
            @delete-reocrd="deleteRecord"
            @enter-record="enterRecord"
            @show-record-disabled-tip="showRecordDisabledTip"
            @enter-qN="enterQN"
          />
        </div>
        <Sort v-if="isSortVisible" @hide-sort="sortPatients" :sortSettings="sortSettings"></Sort>
      </div>
      <div class="wrapper-full" name="dry-eye" v-if="currentPage === pages.settings"></div>
      <div class="wrapper-full" name="dry-eye" v-if="currentPage === pages.dryeye">
        <DryEye
          :subPage="currentSubPage"
          :language="focusLanguage"
          :currentPatient="currentPatient"
          :currentRecord="currentRecord"
          :currentEye="currentEye"
          @show-capture="showCapture"
        />
      </div>
      <div v-if="currentPage === pages.topography" class="wrapper-full" name="topography">
        <Topography
          :subPage="currentSubPage"
          :currentPatient="currentPatient"
          :record="currentRecord"
          :casePath="casePath"
          :currentEye="currentEye"
          :pupilCorneaMode="pupilCorneaMode"
          :currentPupilCornea="currentPupilCornea"
          @show-waiting="showWaiting"
          @hide-waiting="hideWaiting"
          @update-record="updateRecord"
          @show-capture="showCapture"
        />
      </div>
      <div v-if="currentPage === pages.questionnaire" class="wrapper-full" name="questionnaire">
        <Questionnaire
          :currentRecord="currentRecord"
          :currentPatient="currentPatient"
          @delete-reocrd="deleteRecord"
        />
      </div>
      <div v-if="currentPage === pages.capture" class="wrapper-full" name="capture">
        <Capture
          :focusLanguage="focusLanguage"
          :forupDownInCaptrue="forupDownInCaptrue"
          :menuItems="menuItems"
          :checkType="checkType"
          :currentRecord="currentRecord"
          :mode="currentSubPage"
          :dispH="captureHeight"
          :upDown="upDown"
          :currentPupilCornea="currentPupilCornea"
          @select-subpage="selectSubPage"
          @update-record="updateRecord"
          @show-waiting="showWaiting"
          @hide-waiting="hideWaiting"
          @take-photo-video-finished="procPhotoVideo"
        />
      </div>
      <div v-show="isSettingsVisible" v-if="!isLoginVisible" class="wrapper-full" name="settings">
        <GSettings
          @change-language="changeLanguage"
          @back-to-patientmanager="back2PatientManager"
          @re-login="logout"
          @check-usbdriver="checkUsbdriver"
          :isKeyboardLoading="isKeyboardLoading"
          :refresCnt="refresCnt"
          :currentPage="currentPage"
          :mode="currentSubPage"
          :curSetting="curSubSetting"
          :usbDriver="usbDriver"
          v-model="isSettingsVisible"
        />
      </div>
      <div v-if="isWaittingVisible" class="global-waitting">
        <div class="waitting-content">
          <span class="el-icon-loading waitting-icon"></span>
          <span class="waitting-text">{{ waittingText }}</span>
        </div>
      </div>
      <!-- 软键盘 -->
    </div>
    <ScreenSaver v-if="isScreenSaveVisible" />
    <!-- 导出页面-->
    <div class="export-userList" v-if="isExportDialogVisible && !isLoginVisible">
      <!-- <exportUserList :patientHeaders="patientHeaders" @hideExport="hideExport">
      </exportUserList> -->
      <exportData @close-export="isExportDialogVisible = false"></exportData>
    </div>
    <exportPatientAndRecord
      v-if="showExportAllData && !isLoginVisible"
      @close-export="showExportAllData = false"
      @show-waiting="showWaiting"
      @hide-waiting="hideWaiting"
    ></exportPatientAndRecord>
    <!-- 键盘输入框 -->
    <!-- <div class="keyboard keyboard-containner" v-show="keyboardState">
      <div class="keyboard-method">
        <div v-for="item in inputmethods" :key="item.key">
          <el-radio-group v-model="inputmethod" text-color="#00ff00">
            <el-radio
              :label="item.key"
              text-color="#00ff00"
              @change="selectMethod"
              style="margin-left:20px;"
            >
              {{ item.label }}</el-radio
            >
          </el-radio-group>
        </div>
      </div>
      <div class="keykoard-input">
        <el-input id="lockInput" v-model="currentInput" clearable></el-input>
        <span class="btn" @click="hideKeyboard">▼</span>
      </div>
    </div> -->
  </div>
</template>
<script>
import exportUserList from "./mainInterface/components/exportUserList";
import exportData from "./mainInterface/components/exportData";
import exportPatientAndRecord from "./mainInterface/components/ExportPatientAndRecord";
import { mapActions, mapState, mapGetters } from "vuex";
import TitleBar from "./mainInterface/components/TitleBar";
import DelectSettings from "./mainInterface/components/settings/DelectSettings.vue";
import PatientList from "./mainInterface/components/PatientList";
import RecordList from "./mainInterface/components/RecordList";
import Capture from "./mainInterface/components/Capture";
import Questionnaire from "./dryeye/QuestionNaire";
import Menu from "./mainInterface/components/basic/Menu";
import Sort from "./mainInterface/components/Sort";
import GSettings from "./mainInterface/components/GSettings";
import Login from "./mainInterface/components/Login.vue";
import DryEye from "./dryeye/DryEye";
import Topography from "./topography/Topography";
import ScreenSaver from "./mainInterface/components/ScreenSaver.vue";
import { Message, Size } from "./mixins";
import EVENTS from "./bus";
import {
  PAGES,
  DRYEYEMENUS,
  TOPOGRAPHYMENUS,
  CHECKTYPES,
  TOPOGRAPHYCAMPTUREMODES,
  TOPOGRAPHYMODES,
  DRYEYEMODES
} from "./shared/consts";
import {
  isDefined,
  isArrayEmpty,
  objectCopy,
  isFunction,
  isTrue,
  deepCopy,
  isLocalServer,
  json2string,
  getSystemTime,
  logStdout
} from "./shared/utils";
import * as patient from "./services/patient";
import * as record from "./services/record";
import login, { keepAlive } from "./services/login";
import DryEyeRecordProc from "./dryeye/js/DryEyeRecordProc";
import TopographyProc from "./topography/js/TopographyRecordProc";
import { updateMarking } from "./services/media";
import fileSys from "./fileoprators/fileSystem";
import home from "./store/modules/home";
import wpaWIfi from "./mainInterface/js/wifi/wpa_wifi";
import { saveCaptureSettings } from "./settings";
import enus from "element-ui/lib/locale/lang/en";
import zhcn from "element-ui/lib/locale/lang/zh-CN";
import ja from "element-ui/lib/locale/lang/ja";
import de from "element-ui/lib/locale/lang/de";
import it from "element-ui/lib/locale/lang/it";
import locale from "element-ui/lib/locale";
import { procHttpDataError } from "./services/httpreq";
import { nibutInfrared } from "./fileoprators/license";
let screenSaveTimer;
let capTimeout;
const { ipcRenderer } = window.require("electron");
let dryeyeRecordProc = new DryEyeRecordProc();
let topographyRecordProc = new TopographyProc();
// import '../test/setting'
let _page = 1;
let _sort = {
  key: "creationdate",
  asc_desc: -1
};
let _EyeType = "";
let _search;
let timeoutWaitting;
let timeout;
let _originalPatients = [];
let _index = -1;
let _canLoadMorePatients = true;
let timeoutSwitchSubpage;
let _inputCallback;
let timerHideWaiting;
let docEvents = ["keydown", "mouseup", "touchend"];
// let cEvents = ['mousemove', 'touchmove']
let interDiskDetect;
export default {
  name: "App",
  data() {
    return {
      isNewInfrared: window.isNewInfrared(),
      isWaittingVisible: false,
      delectSettingsVisible: false,
      waittingText: "请等待...",
      currentPage: PAGES.patientmanager,
      pages: PAGES,
      checkType: CHECKTYPES.dryeye,
      patients: [],
      currentPatient: undefined,
      records: [],
      currentRecord: undefined,
      isEdittingVisible: false,
      menuItems: this.procMenus(CHECKTYPES.dryeye),
      currentSubPage: "questionnaire",
      isSortVisible: false,
      sortSettings: _sort,
      currentEye: "OD",
      needDelPhotos: [],
      upDown: "up",
      casePath: "",
      isSettingsVisible: false,
      pupilCorneaMode: "pupildia",
      dialogVisible: false,
      keyboardHtml: "file://" + fileSys.getUtilPath(`keyboard/${window.settings.language}.html`),
      isKeyboardVisible: true,
      isKeyboardLoading: false,
      isReCaptureConfirmShow: false,
      allPatientsCount: 0,
      patientPage: 1,
      forupDownInCaptrue: "up",
      isNonePatient: true,
      isScreenSaveVisible: false,
      refresCnt: 1,
      patientHeaders: patient.initHeaders(),
      isExportDialogVisible: false, // /导出弹窗显示隐藏
      showExportAllData: false, // /导出弹窗显示隐藏
      focusLanguage: "",
      isLoginVisible: !window.loginInfo,
      nextState: false,
      curSubSetting: "",
      canLogout: true,
      usbDriver: { status: false },
      currentPupilCornea: "",
      inputmethod: "fcitx-keyboard-us",
      inputmethods: [
        {
          key: "pinyin",
          label: this.$t("langcfg.txtChinese")
        },
        {
          key: "fcitx-keyboard-us",
          label: this.$t("langcfg.txtEnglish")
        },
        {
          key: "anthy",
          label: this.$t("langcfg.txtJapanese")
        }
        // {
        //   key: 'chewing',
        //   label: this.$t('langcfg.txtTaiwanese')
        // }
      ],
      currentInput: "",
      keyboardState: false,
      captureCallback: null
    };
  },
  components: {
    TitleBar,
    PatientList,
    RecordList,
    Capture,
    Menu,
    DryEye,
    Sort,
    Topography,
    GSettings,
    ScreenSaver,
    Questionnaire,
    exportUserList,
    Login,
    exportData,
    exportPatientAndRecord,
    DelectSettings
  },
  mixins: [Message, Size],
  props: {
    propCurrentPatient: {
      type: Object
    },
    propRecords: {
      type: Array
    }
  },
  created() {
    this.patientHeaders = patient.initHeaders();
    let result = fileSys.readJsonFile(fileSys.getTmpFilePath("patient.json"));
    this.currentPatient = (result || {}).patient;
    this.patientPage = (result || {}).page;
    _page = this.patientPage;
    this.sortSettings = window.settings.sort;
    if (window.captureSettings.lipidlayertime === 11) {
      window.captureSettings.lipidlayertime = 10;
      saveCaptureSettings(window.captureSettings);
    }
    if (isDefined(window.loginInfo)) {
      login(window.loginInfo, (data) => {
        if (data.message === "OK") {
          this.isLoginVisible = false;
          this.searchPatients();
        }
      });
    }

    // 初始设置时区
    const timeZone = window.settings.timeZone.zone + "/" + window.settings.timeZone.city;
    fileSys.setTimezone(timeZone, (err) => {
      if (err) {
        console.log(err);
      } else {
        setTimeout(() => {
          this.$bus.$emit("updateTime");
        }, 1000);
      }
    });
  },
  methods: {
    // selectMethod (key) {
    //   document.getElementById('lockInput').focus()
    //   fileSys.toggleInputMethod(key)
    // },
    enterRecordPupilCorneaDia() {
      if (!this.currentRecord) {
        this.message(this.$t("langcfg.txtNoData"), "warning", 2000);
        return;
      }
      if (
        this.currentRecord.content[`data${this.currentEye}`].pupilcorneadia_dark ||
        this.currentRecord.content[`data${this.currentEye}`].pupilcorneadia ||
        this.currentRecord.content[`data${this.currentEye}`].pupilcorneadia_lowerMiddle ||
        this.currentRecord.content[`data${this.currentEye}`].pupilcorneadia_middle ||
        this.currentRecord.content[`data${this.currentEye}`].pupilcorneadia_bright ||
        this.currentRecord.content[`data${this.currentEye}`].pupilcorneadia_dynamic
      ) {
        this.enterRecord(this.currentRecord, "pupilcorneadia", this.currentEye);
      } else {
        let otherEye = this.currentEye === "OD" ? "OS" : "OD";

        if (
          this.currentRecord.content[`data${otherEye}`].pupilcorneadia_dark ||
          this.currentRecord.content[`data${otherEye}`].pupilcorneadia ||
          this.currentRecord.content[`data${otherEye}`].pupilcorneadia_lowerMiddle ||
          this.currentRecord.content[`data${otherEye}`].pupilcorneadia_middle ||
          this.currentRecord.content[`data${otherEye}`].pupilcorneadia_bright ||
          this.currentRecord.content[`data${otherEye}`].pupilcorneadia_dynamic
        ) {
          this.enterRecord(this.currentRecord, "pupilcorneadia", otherEye);
        } else {
          this.message(this.$t("langcfg.txtNoData"), "warning", 2000);
        }
      }
    },
    hideKeyboard() {
      // fileSys.killallExe('onboard')
      this.keyboardState = false;
      if (_inputCallback) _inputCallback(this.currentInput);
    },
    logout() {
      if (!this.canLogout) return;
      window.session = undefined;
      window.token = "";
      this.isLoginVisible = true;
      this.isSettingsVisible = false;
      this.currentPatient = undefined;
      this.records = [];
      this.patients = [];
      this.currentPage = PAGES.patientmanager;
    },
    checkUsbdriver(result) {
      this.usbDriver = window.usbDriver = objectCopy(result);
    },
    loginSuccess() {
      this.isLoginVisible = false;
      _search = {};
      _page = 1;
      this.currentPatient = undefined;
      this.patientPage = 1;
      this.patientNameChanged(null);
      this.searchPatients();
    },

    testPatient(callback, pid = 1) {
      if (pid > 30) {
        callback();
      } else {
        let newpat = {
          firstname: "Name" + pid,
          pid: pid.toString().padStart(10, "0")
        };
        pid += 1;
        patient.addPatient(newpat, () => {
          this.testPatient(callback, pid);
        });
      }
    },
    addThirdpartyPatients(pats, callback) {
      if (pats.length <= 0) {
        if (callback) callback();
        if (this.currentPage === PAGES.patientmanager && !this.isSettingsVisible) {
          this.records = [];
          if (window.token === "") return;
          this.getPatients((pats, count) => {
            _originalPatients = pats.concat();
            this.patients = patient.normalPatients(_originalPatients);
            this.allPatientsCount = count;
            if (!isDefined(this.currentPatient)) {
              this.currentPatient = _originalPatients[0];
            }
          });
        }
      } else {
        let pat = pats.pop();
        pat = window.thirdpartyScript.normal2localPatient(pat);
        let treatId =
          typeof pat["thirdData"].treatId === "number"
            ? pat["thirdData"].treatId.toString()
            : pat["thirdData"].treatId;
        patient.getOnePatient(
          {
            search: {
              $and: [{ firstname: pat.firstname }, { lastname: pat.lastname }, { treatid: treatId }]
            },
            matchall: true
          },
          (data) => {
            if (data.message === "OK") {
              if (!isDefined(data.patient)) {
                pat["treatid"] = treatId;
                patient.addPatient(pat, (data) => {
                  if (data.message === "OK") {
                    this.addThirdpartyPatients(pats, callback);
                  } else {
                    if (callback) callback();
                  }
                });
              } else {
                this.addThirdpartyPatients(pats, callback);
              }
            } else {
              if (callback) callback();
            }
          }
        );
      }
    },
    stopThirdPartyDownloadPatient() {
      if (window.thirdpartyScript && window.thirdpartyScript.clearDownloadTimer) {
        window.thirdpartyScript.clearDownloadTimer();
      }
    },
    startThirdPartyDownloadPatient() {
      if (
        fileSys.isThirdPartyEnabled() &&
        typeof window.thirdpartyScript.startGetPatient === "function" &&
        typeof window.thirdpartyScript.normal2localPatient === "function"
      ) {
        window.thirdpartyScript.startGetPatient((res) => {
          if (res.code === 200) {
            this.message(res.message, "success");
            if (res.data && res.data.length > 0) {
              this.addThirdpartyPatients(res.data);
            }
          } else {
            if (this.currentPage === PAGES.patientmanager && !this.isSettingsVisible) {
              this.message(res.message, "error");
            }
          }
        });
      }
    },
    getThirdPartyDownloadPatient() {
      if (
        fileSys.isThirdPartyEnabled() &&
        typeof window.thirdpartyScript.startGetPatient === "function" &&
        typeof window.thirdpartyScript.normal2localPatient === "function"
      ) {
        window.thirdpartyScript.getPatient((res) => {
          if (res.code === 200) {
            this.message(res.message, "success");
            if (res.data && res.data.length > 0) {
              this.addThirdpartyPatients(res.data);
            }
          } else {
            if (this.currentPage === PAGES.patientmanager && !this.isSettingsVisible) {
              this.message(res.message, "error");
            }
          }
        });
      }
    },
    showExport() {
      this.isExportDialogVisible = !this.isExportDialogVisible;
    },
    hideExport() {
      this.isExportDialogVisible = false;
    },
    ...mapActions({
      patientNameChanged: "home/patientNameChanged",
      loginStateChanged: "home/loginStateChanged",
      currentEyeTypeChanged: "home/currentEyeTypeChanged",
      mapDrawSettingsChanged: "topography/mapDrawSettingsChanged"
    }),
    changePage(page) {
      _page = page;
    },
    hideScreenSaver() {
      // for (let id in docEvents) {
      //   document.removeEventListener(docEvents[id], this.event)
      // }
      this.isScreenSaveVisible = false;
      this.saveScreen();
    },
    showScreenSaver() {
      if (this.canLogout) {
        this.hideWaiting();
        this.logout();
        this.isScreenSaveVisible = true;
      }
    },
    patientPageChanged(page) {
      _page = page;
      this.searchPatients();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    setSettingsVisible(state) {
      this.refresCnt = Math.random();
      this.isSettingsVisible = state;
    },
    changeLanguage() {
      this.showWaiting(this.$t("langcfg.txtKeyboardReloading"));
      let langs = {
        en_US: enus,
        de: de,
        ja: ja,
        zh_CN: zhcn,
        it: it
      };
      this.inputmethods = [
        {
          key: "pinyin",
          label: this.$t("langcfg.txtChinese")
        },
        {
          key: "fcitx-keyboard-us",
          label: this.$t("langcfg.txtEnglish")
        },
        {
          key: "anthy",
          label: this.$t("langcfg.txtJapanese")
        }
      ];
      locale.use(langs[window.settings.language]);
      this.isKeyboardLoading = true;
      this.records = [];
      this.searchPatients(_search);
      this.focusLanguage = window.settings.language;
      this.$store.state.dryeye.windowLanguage = window.settings.language;
      if (this.currentPage !== "capture") {
        this.menuItems = this.procMenus(this.checkType, this.currentRecord);
      }
      this.matchLanguage();
    },
    // 匹配字库url
    matchLanguage() {
      this.keyboardHtml =
        "file://" +
        fileSys.getUtilPath(
          `keyboard/${window.settings.language === "de" ? "en_US" : window.settings.language}.html`
        );
    },
    sortPatients(sort) {
      this.isSortVisible = false;
      this.sortSettings = window.settings.sort = sort;
      this.searchPatients();
    },
    showSort() {
      this.isSortVisible = true;
    },
    isCheckItemDiagnosed(subpage, eyetype) {
      let et = eyetype || this.currentEye;
      console.log("---hzx---this.currentRecord", this.currentRecord);
      console.log("---hzx---subpage", subpage);
      return (
        isDefined(this.currentRecord) &&
        isDefined(this.currentRecord.content) &&
        isDefined(this.currentRecord.content[`data${et}`]) &&
        isTrue(this.currentRecord.content[`data${et}`].diagnosed) &&
        isDefined(this.currentRecord.content[`data${et}`][subpage]) &&
        isTrue(
          this.currentRecord.content[`data${et}`][subpage].diagnosed ||
            (subpage === "fbut"
              ? this.currentRecord.content[`data${et}`][subpage][0].diagnosed
              : false)
        )
      );
    },

    selectEyeType(eyetype) {
      this.currentEye = eyetype || (this.currentEye === "OS" ? "OD" : "OS");
      this.menuItems = this.procMenus(this.checkType, this.currentRecord);
      if (this.currentPage === PAGES.topography) {
        console.log(
          "---hzx--- 213123",
          this.isCheckItemDiagnosed(this.currentPage, this.currentEye)
        );
        if (this.isCheckItemDiagnosed(this.currentPage, this.currentEye)) {
          this.currentPage = "";
          let _subpage = this.currentSubPage;
          this.currentSubPage = "";
          this.$nextTick(async () => {
            await this.enterTopography(this.currentSubPage, this.currentEye);
            this.currentSubPage = _subpage;
            this.selectSubPage(this.currentSubPage);
          });
        } else {
          this.selectSubPage(this.currentSubPage);
        }
      } else {
        this.selectSubPage(this.currentSubPage);
      }
    },
    saveScreen(e) {
      // if (isDefined(e) && isFunction(e.preventDefault)) { e.preventDefault() }
      // if (isDefined(e) && isFunction(e.stopPropagation)) { e.stopPropagation() }
      clearTimeout(screenSaveTimer);
      if (window.settings.screensavetime <= 0) {
        return;
      }
      screenSaveTimer = setTimeout(
        () => {
          // this.keyboardState = false
          // fileSys.killallExe('onboard')
          this.showScreenSaver();
        },
        1000 * 60 * (window.settings.screensavetime || 5)
      );
    },
    delay() {
      return new Promise((resolve, reject) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          resolve();
        }, 300);
      });
    },
    async selectSubPage(subpage, mode) {
      this.hideWaiting();
      if (this.currentSubPage !== subpage && this.checkType === PAGES.topography) {
        this.showWaiting(this.$t("langcfg.txtLoading"));
        await this.delay();
      }
      this.currentSubPage = subpage === PAGES.topography ? "largemap" : subpage;
      let _subpage = subpage;
      let capPage = subpage;
      if (subpage !== "report") {
        if (this.checkType === PAGES.topography) {
          if (
            subpage !== TOPOGRAPHYMODES.pupilcorneadia.key &&
            subpage !== "pupilcorneadia_dark" &&
            subpage !== "pupilcorneadia_lowerMiddle" &&
            subpage !== "pupilcorneadia_middle" &&
            subpage !== "pupilcorneadia_bright" &&
            subpage !== "pupilcorneadia_dynamic"
          ) {
            _subpage = PAGES.topography;
            capPage = PAGES.topography;
          }
        }
        if (subpage === "pupilcorneadia" && !mode) {
          if (this.isCheckItemDiagnosed("pupilcorneadia_dark")) {
            mode = "pupilcorneadia_dark";
          } else if (this.isCheckItemDiagnosed("pupilcorneadia_lowerMiddle")) {
            mode = "pupilcorneadia_lowerMiddle";
          } else if (this.isCheckItemDiagnosed("pupilcorneadia_middle")) {
            mode = "pupilcorneadia_middle";
          } else if (this.isCheckItemDiagnosed("pupilcorneadia_bright")) {
            mode = "pupilcorneadia_bright";
          } else if (this.isCheckItemDiagnosed("pupilcorneadia_dynamic")) {
            mode = "pupilcorneadia_dynamic";
          }
        }
        if (this.isCheckItemDiagnosed(mode ? mode : _subpage)) {
          //
          this.checkType = this.currentRecord.checktype;
          this.currentPage = this.checkType;
          this.menuItems = this.procMenus(this.checkType, this.currentRecord);
        } else {
          this.currentSubPage = capPage;
          //
          this.showCapture(this.checkType, capPage);
        }
      } else {
      }
    },
    showRecordDisabledTip() {
      this.message(this.$t("langcfg.txtPleaseFinishEditPatientToOperate"), "warning", 3000);
    },
    afterUpdateRecord(res, mode, eyetype, callback, rec) {
      if (res.message === "OK") {
        if (isDefined(rec)) {
          this.enterRecord(rec, mode, eyetype);
        } else {
          this.enterRecord(res.record, mode, eyetype);
        }
      } else {
        this.camera.setProcessingData(false);

        // if (mode === 'tearheight') {
        //   this.notify(this.$t('langcfg.txtFailToTearHeight'), '', 'error')
        // } else {
        this.message(this.$t("langcfg.txtFailToCapture"), "error");
        // }
      }
      if (isFunction(callback)) {
        callback();
      }
    },
    changeSubpageByAutoEyeType(eyetype) {
      clearTimeout(timeoutSwitchSubpage);
      timeoutSwitchSubpage = setTimeout(() => {
        this.selectEyeType(eyetype);
      }, 2000);
    },
    eyeTypeRecognise() {
      if (isDefined(global.LiftDevice)) {
        global.LiftDevice.regListen((data) => {
          if (!isDefined(data)) return;
          // logStdout("eyetype and shot data from serial", data);
          let flag = false;
          let et = data.substring(4, 5);
          let shot = data.substring(6, 7);
          let startShot = shot === "0";
          let eyetype = et === "1" ? "OD" : "OS";
          if (startShot && this.isScreenSaveVisible) {
            this.hideScreenSaver();
            return;
          }
          if (_EyeType !== eyetype && this.currentPage === PAGES.capture) {
            _EyeType = eyetype;
            if (this.isScreenSaveVisible) {
              this.hideScreenSaver();
              return;
            }
            flag = true;
          }
          if (this.currentPage === PAGES.capture) {
            this.currentEye = eyetype;
            if (flag) {
              this.menuItems = this.procMenus(this.checkType, this.currentRecord, true, eyetype);
            }

            this.$bus.$emit(EVENTS.eyeTypeShot, eyetype, startShot);
          } else {
            if (global.isCalibrationShow) {
              this.$bus.$emit(EVENTS.eyeTypeShot, eyetype, startShot);
            }
            if (startShot && this.isReCaputreVisible) {
              if (!this.isScreenSaveVisible) {
                clearTimeout(capTimeout);
                capTimeout = setTimeout(() => {
                  this.showCapture(this.checkType, this.initCapureMode(this.currentSubPage));
                }, 300);
              } else {
                this.hideScreenSaver();
              }
            }
          }
        });
      }
    },
    procPhotoVideo(checktype, mode, media, eyetype, data, pupilcornea, callback) {
      if (checktype === PAGES.dryeye) {
        dryeyeRecordProc.init(this.currentPatient, this.currentRecord, media, eyetype, mode, data);
        dryeyeRecordProc.procData((err, cmd, newRecord) => {
          console.log(err, cmd, newRecord);
          if (!isDefined(err)) {
            if (cmd === "addRecord") {
              record.addRecord(newRecord, (res) => {
                this.afterUpdateRecord(res, mode, eyetype, callback);
              });
            } else {
              this.updateRecord(newRecord, (res) => {
                this.afterUpdateRecord(res, mode, eyetype, callback, newRecord);
              });
            }
          } else {
            this.afterUpdateRecord({ message: "failed" }, mode, eyetype, callback);
          }
        });
      } else {
        topographyRecordProc.init(
          this.currentPatient,
          this.currentRecord,
          mode,
          media,
          eyetype,
          pupilcornea
        );
        this.pupilCorneaMode = pupilcornea;
        topographyRecordProc.procData((err, cmd, newRecord) => {
          console.log("takePhoto topographyRecordProc.procData finished", err);
          if (isDefined(err)) {
            this.afterUpdateRecord({ message: "failed" }, mode, eyetype, callback);
            return;
          }
          let _mode =
            mode === TOPOGRAPHYMODES.pupilcorneadia.key
              ? TOPOGRAPHYMODES.pupilcorneadia.key
              : "largemap";
          if (cmd === "addRecord") {
            record.addRecord(newRecord, (res) => {
              if (mode === "pupilcorneadia") {
                this.currentRecord = res.record;
                this.$bus.$emit("initCamera", res.record);
                // setTimeout(() => {
                //   this.$bus.$emit('initCam', pupilcornea)
                //   this.hideWaiting()
                // }, 200)
                this.hideWaiting();
                if (isFunction(callback)) {
                  callback();
                }
                return;
              }
              this.afterUpdateRecord(res, _mode, eyetype, callback);
            });
          } else {
            this.updateRecord(newRecord, (res) => {
              if (mode === "pupilcorneadia") {
                this.currentRecord = newRecord;
                this.$bus.$emit("initCamera", newRecord);
                // setTimeout(() => {
                //   this.$bus.$emit('initCam', pupilcornea)
                //   this.hideWaiting()
                // }, 200)
                this.hideWaiting();
                if (isFunction(callback)) {
                  callback();
                }
                return;
              }
              this.afterUpdateRecord(res, _mode, eyetype, callback, newRecord);
            });
          }
        });
      }
    },

    back2PatientManager() {
      this.currentPage = PAGES.patientmanager;
      if (isDefined(this.currentPatient)) {
        this.getRecords(this.currentPatient._id);
      }
    },
    addPatient(newpat) {
      patient.getOnePatient(
        {
          matchall: true,
          search: {
            pid: newpat.pid
          }
        },
        (data) => {
          if (data.message === "OK") {
            if (isDefined(data.patient)) {
              this.message(this.$t("langcfg.txtSamePid"), "error");
            } else {
              patient.addPatient(newpat, (data) => {
                if (data.message === "OK") {
                  this.isEdittingVisible = false;
                } else {
                  procHttpDataError(this, data, this.$t("langcfg.txtFailToAddPatient"));
                  return;
                }
                this.currentRecord = null;
                _originalPatients.unshift(data.patient);
                this.allPatientsCount += 1;
                this.patients = patient.normalPatients(_originalPatients);
                this.currentPatient = data.patient;
                this.message(this.$t("langcfg.txtSuccessToAddPatient"), "success");
                this.sendChangeStatus();
              });
            }
          } else {
            procHttpDataError(this, data, this.$t("langcfg.txtFailToAddPatient"));
          }
        }
      );
    },
    deletePatient() {
      if (isDefined(this.currentPatient)) {
        this.confirm(
          this.$t("langcfg.txtConfirmToDelPatient"),
          this.$t("langcfg.txtOK"),
          this.$t("langcfg.txtCancel")
        )
          .then(() => {
            let _id = this.currentPatient._id;
            patient.delPatient(
              _id,
              (data) => {
                if (data.message !== "OK") {
                  procHttpDataError(this, data, this.$t("langcfg.txtFailToDelPatient"));
                } else {
                  this.message(this.$t("langcfg.txtSuccessToDelPatient"));
                }
                this.currentPatient = undefined;
                this.searchPatients();
                this.sendChangeStatus();
              },
              this.currentPatient
            );
          })
          .catch((e) => {});
      } else {
        this.message(this.$t("langcfg.txtSelectPatientToDel"), "info");
      }
    },

    getPatients(callback, showTip = true) {
      let sort = {
        [this.sortSettings.key]: this.sortSettings.asc_desc
      };
      let opt = {
        page: _page,
        pagelength: window.copyScreen ? 12 : 14,
        sort: sort,
        search: _search
      };
      patient.getPatients(opt, (data) => {
        let pats = [];
        let count = 0;
        if (data.message === "OK") {
          pats = data.patients;
          count = data.allPatientsCount;
          if (pats.length === 0 && _page > 1) {
            _page -= 1;
            this.patientPage = _page;
            this.getPatients(callback, showTip);
            return;
          }
        } else {
          if (showTip) {
            procHttpDataError(this, data, this.$t("langcfg.txtFailedToGetPatient"));
          }
        }
        if (isDefined(callback)) {
          callback(pats, count);
        }
      });
    },
    searchPatients(search, callback, callback2) {
      this.getThirdPartyDownloadPatient();
      _search = search || _search;
      _page = _page || 1;
      this.records = [];
      if (window.token === "") return;
      this.getPatients((pats, count) => {
        if (isDefined(callback)) {
          callback(pats, count);
        } else {
          _originalPatients = pats.concat();
          this.patients = patient.normalPatients(_originalPatients);
          this.allPatientsCount = count;
          if (!isDefined(this.currentPatient) && _originalPatients.length) {
            this.currentPatient = _originalPatients[0];
          } else if (!_originalPatients.length) {
            this.currentPatient = undefined;
          }
          if (isFunction(callback2)) {
            callback2();
          }
        }
      });
    },
    showEditPatient() {
      this.isEdittingVisible = !this.isEdittingVisible;
    },
    hasSamePid(patients, _id) {
      if (patients.length <= 0) {
        return false;
      }
      if (patients.length === 1) {
        if (patients[0]._id === _id) {
          return false;
        } else {
          return true;
        }
      }
      return true;
    },
    updatePatient(newpat) {
      if (_index < 0) return;
      patient.getPatients(
        {
          matchall: true,
          search: {
            pid: newpat.pid
          }
        },
        (data) => {
          if (data.message === "OK") {
            if (this.hasSamePid(data.patients, newpat._id)) {
              this.message(this.$t("langcfg.txtSamePid"), "error");
            } else {
              patient.updatePatient(newpat, (data) => {
                if (data.message === "OK") {
                  _originalPatients[_index] = objectCopy(newpat);
                  this.patients.splice(_index, 1, patient.normalPatient(_index, newpat));
                  this.isEdittingVisible = false;
                  this.message(this.$t("langcfg.txtSuccessToUpdatePatient"), "success");
                  this.sendChangeStatus();
                } else {
                  procHttpDataError(this, data, this.$t("langcfg.txtFailToUpdatePatient"));
                }
              });
            }
          } else {
            this.message(this.$t("langcfg.txtFailToUpdatePatient"), "error");
          }
        }
      );
    },
    selectPatient(pat) {
      if (isDefined(pat)) {
        _index = pat.index;
        if (!isArrayEmpty(_originalPatients)) {
          this.currentPatient = _originalPatients[_index];
          this.patientNameChanged(this.currentPatient);
          this.mapDrawSettingsChanged();
          this.getRecords(pat._id);
        }
      } else {
        // 没有数据时姓名为空
        this.patientNameChanged(null);
      }
    },

    loadPrePatients(callback) {
      _page = 1;
      this.searchPatients(_search, (pats) => {
        _originalPatients = pats;
        this.patients = patient.normalPatients(pats);
        if (isFunction(callback)) {
          callback();
        }
      });
    },
    loadNextPatients(callback) {
      if (_canLoadMorePatients) {
        _page += 1;
        this.searchPatients(_search, (pats) => {
          this.patients = this.patients.concat(patient.normalPatients(pats));
          _originalPatients = _originalPatients.concat(pats);
          _canLoadMorePatients = pats.length >= 100;
          if (this.patients.length > 1000) {
            this.message(this.$t("langcfg.txtTooMuchDataAndUseSearchToFind"), "warning");
          }
          if (isFunction(callback)) {
            callback();
          }
        });
      }
    },
    isDiagnosed(data, key, eyetype) {
      if (key === PAGES.questionnaire) {
        return isTrue((data["userQuestionnaire"] || {}).diagnosed);
      }
      let _eyetype = eyetype || this.currentEye;
      let _data = data[`data${_eyetype}`] || {};
      if (key === "fbut" && _data[key]) {
        return isTrue((_data[key][0] || {}).diagnosed);
      }
      if (key === "pupilcorneadia" && _data["pupilcorneadia_dark"]) {
        return isTrue((_data["pupilcorneadia_dark"] || {}).diagnosed);
      }
      if (key === "pupilcorneadia" && _data["pupilcorneadia_lowerMiddle"]) {
        return isTrue((_data["pupilcorneadia_lowerMiddle"] || {}).diagnosed);
      }
      if (key === "pupilcorneadia" && _data["pupilcorneadia_middle"]) {
        return isTrue((_data["pupilcorneadia_middle"] || {}).diagnosed);
      }
      if (key === "pupilcorneadia" && _data["pupilcorneadia_bright"]) {
        return isTrue((_data["pupilcorneadia_bright"] || {}).diagnosed);
      }
      if (key === "pupilcorneadia" && _data["pupilcorneadia_dynamic"]) {
        return isTrue((_data["pupilcorneadia_dynamic"] || {}).diagnosed);
      }
      // if (key === "pupilcorneadia") {
      //   return false;
      // }

      return isTrue((_data[key] || {}).diagnosed);
    },
    procMenus(checktype, record, isCapture = false, eyetype) {
      if (checktype === "dryeye") {
        let curTemplate = window.detectSettings.dryeye.templates.find(
          (v) => v.value === window.detectSettings.dryeye.template
        );
        let detectMap = Object.fromEntries(curTemplate.items.map(({ key, show }) => [key, show]));
        let keyOrder = curTemplate.items.map(({ key }) => key);
        const sortKey = (a, b) => {
          let indexA = keyOrder.indexOf(a.key);
          let indexB = keyOrder.indexOf(b.key);
          const orderA = indexA === -1 ? Infinity : indexA;
          const orderB = indexB === -1 ? Infinity : indexB;

          return orderA - orderB;
        };
        let ms = isCapture
          ? DRYEYEMENUS.filter((item) => {
              if (item.key === "questionnaire" && ["de", "it"].includes(window.settings.language)) {
                return false;
              } else {
                return item.visibleInCapture;
              }
            })
              .map((v) => ({ ...v, hidden: !["report"].includes(v.key) && !detectMap[v.key] }))
              .sort(sortKey)
              .concat()
          : DRYEYEMENUS.filter((item) => {
              if (item.key === "questionnaire" && ["de", "it"].includes(window.settings.language)) {
                return false;
              } else {
                return item;
              }
            })
              .map((v) => ({ ...v, hidden: !["report"].includes(v.key) && !detectMap[v.key] }))
              .sort(sortKey)
              .concat();
        let menus = deepCopy(ms);
        if (isDefined(record)) {
          for (let id in menus) {
            menus[id]["diagnosed"] = this.isDiagnosed(record["content"], menus[id].key, eyetype)
              ? "Y"
              : "N";
          }
        }
        if (this.currentSubPage === PAGES.questionnaire) {
          return menus.filter((item) => {
            return item.key !== "report";
          });
        }
        return menus;
      } else {
        let ms = deepCopy(TOPOGRAPHYCAMPTUREMODES);
        let menus = ms.concat();
        if (isCapture) {
          if (isDefined(record)) {
            for (let id in ms) {
              menus[id]["diagnosed"] = this.isDiagnosed(record["content"], menus[id].key, eyetype)
                ? "Y"
                : "N";
            }
          } else {
            return ms;
          }
        } else {
          menus = deepCopy(TOPOGRAPHYMENUS);
          if (isDefined(record)) {
            for (let id in menus) {
              if (menus[id].key === "pupilcorneadia") {
                menus[id]["diagnosed"] = this.isDiagnosed(record["content"], menus[id].key, eyetype)
                  ? "Y"
                  : "N";
              }
            }
          } else {
            return menus;
          }
        }
        return menus;
      }
    },
    getRecords(_id, callback) {
      record.getAllRecordsOfPatientWithoutContent(_id, {}, (data) => {
        if (data.message === "OK") {
          this.records = record.normalRecords(data.records, {
            dryeye: this.$t("langcfg.txtDryEye"),
            topography: this.$t("langcfg.txtTopography")
          });
        } else {
          procHttpDataError(this, data, this.$t("langcfg.txtFailToGetRecord"));
        }
        if (isFunction(callback)) {
          callback();
        }
      });
      // 处理新增问卷模块后会重复新增病例问题
      if (this.questionnaireExists()) {
        if (!this.currentRecord.content.userQuestionnaire.diagnosed) {
          if (this.currentRecord.eyetype || this.currentPage === PAGES.capture) {
          } else {
            this.deleteRecord(this.currentRecord, false);
          }
        }
      } else {
      }
    },
    deleteRecord(rec, hasConfirm) {
      // 新增hasConfirm 参数， 是否有confirm提示框
      if (hasConfirm) {
        this.confirm(
          this.$t("langcfg.txtConfirmToDelRecord"),
          this.$t("langcfg.txtOK"),
          this.$t("langcfg.txtCancel")
        )
          .then(() => {
            record.deleteRecord(rec._id, null, (data) => {
              if (data.message === "OK") {
                this.records.splice(rec.index, 1);
                this.message(this.$t("langcfg.txtSuccessToDelRecord"));
              } else {
                procHttpDataError(this, data, this.$t("langcfg.txtFailToDelRecord"));
              }
              this.getRecords(this.currentPatient._id);
              this.sendChangeStatus();
            });
          })
          .catch(() => {});
      } else {
        record.deleteRecord(rec._id, null, (data) => {
          if (data.message === "OK") {
            this.records.splice(rec.index, 1);
          }
          this.sendChangeStatus();
        });
      }
    },
    updateRecord(newRec, callback) {
      this.currentRecord = objectCopy(newRec);

      record.updateRecord(newRec, (data) => {
        if (isFunction(callback)) {
          callback(data);
        }
      });
    },
    postMsg2Keyboard(data) {
      this.$refs.iframe.contentWindow.postMessage(data, "*");
    },

    // spreadKeyBoard (inputData, callback) {
    //   document.getElementById('lockInput').focus()
    //   this.currentInput = inputData
    //   _inputCallback = callback
    //   fileSys.startJapaneseKeyboard()
    //   // if (window.settings.language === 'ja') {
    //   //   fileSys.startJapaneseKeyboard()
    //   // } else {
    //   //   this.dialogVisible = !this.dialogVisible
    //   //   if (isDefined(this.$refs.iframe) && isDefined(this.$refs.iframe.contentWindow)) {
    //   //     let _inputdata = isDefined(inputData) ? inputData : ''
    //   //     this.postMsg2Keyboard({ inputData: _inputdata })
    //   //   }
    //   // }
    // },
    spreadKeyBoard(inputData, callback) {
      _inputCallback = callback;
      this.dialogVisible = !this.dialogVisible;
      if (isDefined(this.$refs.iframe) && isDefined(this.$refs.iframe.contentWindow)) {
        let _inputdata = isDefined(inputData) ? inputData : "";
        this.postMsg2Keyboard({ inputData: _inputdata });
      }
    },
    // 进入拍摄界面
    reCapture(checktype, subpage, updown) {
      this.showCapture(checktype, subpage, updown);
    },
    async showCapture(checktype, subpage, updown) {
      if (this.cameraInited === null) {
        this.showWaiting(`${this.$t("langcfg.txtCameraIniting")}...`, 0, true);
        this.captureCallback = () => this.showCapture(checktype, subpage, updown);
        return;
      }
      if (this.cameraInited === false) {
        this.hideWaiting();
        this.message(this.$t("langcfg.txtCameraInitError"), "error");
        return;
      }
      this.upDown = updown || "up_down";
      if (!isDefined(this.currentPatient)) {
        this.message(this.$t("langcfg.txtSelecOrAddtPatientBeforeCapture"), "error");
        return;
      }
      this.showWaiting();
      if (!isDefined(subpage)) {
        this.currentRecord = undefined;
      }

      checktype = checktype || this.checkType;
      if (this.currentRecord) {
        let checkKeys = [];
        if (checktype === "topography") {
          if (subpage === "pupilcorneadia") {
            checkKeys.push(
              "pupilcorneadia",
              "pupilcorneadia_dark",
              "pupilcorneadia_lowerMiddle",
              "pupilcorneadia_middle",
              "pupilcorneadia_bright",
              "pupilcorneadia_dynamic"
            );
          } else {
            checkKeys.push("topography");
          }
        } else {
          checkKeys.push(subpage);
        }
        let data =
          (this.currentRecord &&
            this.currentRecord.content &&
            this.currentRecord.content[`data${this.currentEye}`]) ||
          {};
        const keys = Object.keys(data);
        let isUpDown =
          subpage === DRYEYEMODES.eyelidedge.key || subpage === DRYEYEMODES.meibomian.key;

        if (
          keys.some((v) =>
            checkKeys.includes(v)
              ? isUpDown
                ? updown
                  ? !!data[v][updown]
                  : !!data[v]["up"] || !!data[v]["down"]
                : true
              : false
          )
        ) {
          if (this.isReCaptureConfirmShow) {
            const confirmButton = document.querySelector(".el-message-box .el-button--primary");
            confirmButton && confirmButton.click();
            return;
          }
          this.isReCaptureConfirmShow = true;
          this.hideWaiting();
          let res = await this.$confirm(
            this.$t("langcfg.txtDetectedPrompt"),
            this.$t("langcfg.txtPrompt"),
            {
              confirmButtonText: this.$t("langcfg.txtContinue"),
              cancelButtonText: this.$t("langcfg.txtCancel"),
              type: "warning"
            }
          ).then(
            (res) => res,
            (err) => err
          );
          if (res === "cancel") {
            this.isReCaptureConfirmShow = false;
            return;
          }
        }
      }
      this.menuItems = this.procMenus(checktype, this.currentRecord, true);
      this.checkType = checktype;
      if (
        this.checkType === CHECKTYPES.dryeye &&
        (!isDefined(subpage) || subpage === DRYEYEMODES.questionnaire.key)
      ) {
        if (window.settings.language === "de") {
          this.currentPage = PAGES.capture;
          this.currentSubPage = DRYEYEMODES.tearheight.key;
        } else {
          this.currentPage = PAGES.questionnaire;
          this.currentSubPage = DRYEYEMODES.questionnaire.key;
        }
      } else {
        this.currentPupilCornea = subpage;
        if (subpage === "scotopia" || subpage === "dynamicpupil") subpage = "pupilcorneadia";
        this.currentPage = PAGES.capture;
        window.curPage = this.currentSubPage = this.initCapureMode(subpage);
      }
      this.isReCaptureConfirmShow = false;
      this.hideWaiting();
    },
    initSubPage(subpage) {
      return this.checkType === CHECKTYPES.dryeye
        ? subpage || "questionnaire"
        : subpage || "largemap";
    },
    initCapureMode(subpage) {
      if (this.checkType === CHECKTYPES.dryeye) {
        return subpage || "questionnaire";
      } else {
        return subpage === "pupilcorneadia" ? subpage : "topography";
      }
    },
    getDryEyeCurrSubPage(eyetype) {
      for (let id in DRYEYEMODES) {
        if (this.isCheckItemDiagnosed(DRYEYEMODES[id].key, eyetype)) {
          return DRYEYEMODES[id].key;
        }
      }
    },
    isDryEyeOSODDiagnosed(et) {
      console.log(
        "isDryEyeOSODDiagnosed:",
        et,
        this.currentRecord.content,
        this.currentRecord.content[`data${et}`]
      );
      return (
        isDefined(this.currentRecord) &&
        isDefined(this.currentRecord.content) &&
        isDefined(this.currentRecord.content[`data${et}`]) &&
        isTrue(this.currentRecord.content[`data${et}`].diagnosed)
      );
    },
    isDryEyeOSODTearHeightDiagnosed(et) {
      return (
        isDefined(this.currentRecord) &&
        isDefined(this.currentRecord.content) &&
        isDefined(this.currentRecord.content[`data${et}`]) &&
        isDefined(this.currentRecord.content[`data${et}`]["tearheight"]) &&
        isTrue(this.currentRecord.content[`data${et}`]["tearheight"].diagnosed)
      );
    },
    enterDryEye(subpage, eyetype) {
      if (!isDefined(eyetype)) {
        if (this.isDryEyeOSODDiagnosed("OD")) {
          this.currentSubPage = this.getDryEyeCurrSubPage("OD");
          this.currentEye = "OD";
          if (this.isDryEyeOSODTearHeightDiagnosed("OD")) {
            if (!this.currentRecord.content["dataOD"]["tearheight"].hasOwnProperty("upArrayX")) {
              let { tearheight } = this.currentRecord.content["dataOD"];
              dryeyeRecordProc.recalculateTearHeihgt(
                objectCopy(this.currentRecord),
                tearheight.photos.filter((photo) => photo.imagelabel === "original")[0],
                "OD",
                (err, record) => {
                  console.log(err);
                  if (!err) {
                    this.$bus.$emit(EVENTS.updateData, record, {}, {}, () => {});
                  }
                  if (
                    this.isDryEyeOSODTearHeightDiagnosed("OS") &&
                    !this.currentRecord.content["dataOS"]["tearheight"].hasOwnProperty("upArrayX")
                  ) {
                    let { tearheight } = this.currentRecord.content["dataOS"];
                    dryeyeRecordProc.recalculateTearHeihgt(
                      objectCopy(this.currentRecord),
                      tearheight.photos.filter((photo) => photo.imagelabel === "original")[0],
                      "OS",
                      (err, record) => {
                        console.log(err);
                        if (!err) {
                          this.$bus.$emit(EVENTS.updateData, record, {}, {}, () => {});
                        }
                        this.menuItems = this.procMenus(this.checkType, this.currentRecord);
                        this.currentPage = PAGES.dryeye;
                        this.hideWaiting();
                      }
                    );
                  } else {
                    this.menuItems = this.procMenus(this.checkType, this.currentRecord);
                    this.currentPage = PAGES.dryeye;
                    this.hideWaiting();
                  }
                }
              );
            } else if (
              this.isDryEyeOSODTearHeightDiagnosed("OS") &&
              !this.currentRecord.content["dataOS"]["tearheight"].hasOwnProperty("upArrayX")
            ) {
              let { tearheight } = this.currentRecord.content["dataOS"];
              dryeyeRecordProc.recalculateTearHeihgt(
                objectCopy(this.currentRecord),
                tearheight.photos.filter((photo) => photo.imagelabel === "original")[0],
                "OS",
                (err, record) => {
                  console.log(err);
                  if (!err) {
                    this.$bus.$emit(EVENTS.updateData, record, {}, {}, () => {});
                  }
                  this.menuItems = this.procMenus(this.checkType, this.currentRecord);
                  this.currentPage = PAGES.dryeye;
                  this.hideWaiting();
                }
              );
            } else {
              this.menuItems = this.procMenus(this.checkType, this.currentRecord);
              this.currentPage = PAGES.dryeye;
              this.hideWaiting();
            }
          } else {
            this.menuItems = this.procMenus(this.checkType, this.currentRecord);
            this.currentPage = PAGES.dryeye;
            this.hideWaiting();
          }
        } else if (this.isDryEyeOSODDiagnosed("OS")) {
          this.currentSubPage = this.getDryEyeCurrSubPage("OS");
          this.currentEye = "OS";
          if (
            this.isDryEyeOSODTearHeightDiagnosed("OS") &&
            !this.currentRecord.content["dataOS"]["tearheight"].hasOwnProperty("upArrayX")
          ) {
            let { tearheight } = this.currentRecord.content["dataOS"];
            dryeyeRecordProc.recalculateTearHeihgt(
              objectCopy(this.currentRecord),
              tearheight.photos.filter((photo) => photo.imagelabel === "original")[0],
              "OS",
              (err, record) => {
                console.log(err);
                if (!err) {
                  this.$bus.$emit(EVENTS.updateData, record, {}, {}, () => {});
                }
                if (
                  this.isDryEyeOSODTearHeightDiagnosed("OD") &&
                  !this.currentRecord.content["dataOD"]["tearheight"].hasOwnProperty("upArrayX")
                ) {
                  let { tearheight } = this.currentRecord.content["dataOD"];
                  dryeyeRecordProc.recalculateTearHeihgt(
                    objectCopy(this.currentRecord),
                    tearheight.photos.filter((photo) => photo.imagelabel === "original")[0],
                    "OD",
                    (err, record) => {
                      console.log(err);
                      if (!err) {
                        this.$bus.$emit(EVENTS.updateData, record, {}, {}, () => {});
                      }
                      this.menuItems = this.procMenus(this.checkType, this.currentRecord);
                      this.currentPage = PAGES.dryeye;
                      this.hideWaiting();
                    }
                  );
                } else {
                  this.menuItems = this.procMenus(this.checkType, this.currentRecord);
                  this.currentPage = PAGES.dryeye;
                  this.hideWaiting();
                }
              }
            );
          } else {
            this.menuItems = this.procMenus(this.checkType, this.currentRecord);
            this.currentPage = PAGES.dryeye;
            this.hideWaiting();
          }
        } else {
          this.currentSubPage = this.initSubPage(subpage);
          this.showCapture(this.checkType, this.currentSubPage);
          this.hideWaiting();
        }
      } else {
        this.currentEye = eyetype;
        this.menuItems = this.procMenus(this.checkType, this.currentRecord);
        this.currentSubPage = this.initSubPage(subpage);
        if (!this.nextState) {
          this.currentPage = PAGES.dryeye;
        }
        this.hideWaiting();
      }
    },
    async enterTopography(subpage, eyetype) {
      let _checkItem = subpage === TOPOGRAPHYMODES.pupilcorneadia.key ? subpage : PAGES.topography;
      if (!isDefined(eyetype)) {
        if (this.isCheckItemDiagnosed(PAGES.topography, "OD")) {
          try {
            this.currentSubPage = "largemap";
            this.casePath = await topographyRecordProc.getRecord(this.currentRecord, "OD");
            this.currentEye = "OD";
            this.menuItems = this.procMenus(this.checkType, this.currentRecord);
            this.currentPage = PAGES.topography;
            this.hideWaiting();
          } catch (e) {
            this.message(this.$t("langcfg.txtFailToGetRecord"), "", "error");
            this.hideWaiting();
            this.currentSubPage = _checkItem;
            this.showCapture(this.checkType, subpage);
          }
        } else if (this.isCheckItemDiagnosed(PAGES.topography, "OS")) {
          try {
            this.currentSubPage = "largemap";

            this.casePath = await topographyRecordProc.getRecord(this.currentRecord, "OS");

            this.currentEye = "OS";
            this.menuItems = this.procMenus(this.checkType, this.currentRecord);
            this.currentPage = PAGES.topography;
            this.hideWaiting();
          } catch (e) {
            this.hideWaiting();
            this.currentSubPage = _checkItem;
            this.showCapture(this.checkType, this.currentSubPage);
          }
        } else if (
          this.isCheckItemDiagnosed("pupilcorneadia_dark", "OD") ||
          this.isCheckItemDiagnosed("pupilcorneadia_lowerMiddle", "OD") ||
          this.isCheckItemDiagnosed("pupilcorneadia_middle", "OD") ||
          this.isCheckItemDiagnosed("pupilcorneadia_bright", "OD") ||
          this.isCheckItemDiagnosed("pupilcorneadia_dynamic", "OD") ||
          this.isCheckItemDiagnosed("pupilcorneadia", "OD")
        ) {
          this.currentSubPage = "pupilcorneadia";
          this.currentEye = "OD";
          this.pupilCorneaMode = this.isCheckItemDiagnosed(PAGES.pupilcorneadia, "OD")
            ? "pupilcorneadia"
            : this.isCheckItemDiagnosed("scotopia", "OD")
              ? "scotopia"
              : "dynamicpupil";
          this.menuItems = this.procMenus(this.checkType, this.currentRecord);
          this.currentPage = PAGES.topography;
          this.hideWaiting();
        } else if (
          this.isCheckItemDiagnosed("pupilcorneadia_dark", "OS") ||
          this.isCheckItemDiagnosed("pupilcorneadia_lowerMiddle", "OS") ||
          this.isCheckItemDiagnosed("pupilcorneadia_middle", "OS") ||
          this.isCheckItemDiagnosed("pupilcorneadia_bright", "OS") ||
          this.isCheckItemDiagnosed("pupilcorneadia_dynamic", "OS") ||
          this.isCheckItemDiagnosed("pupilcorneadia", "OS")
        ) {
          this.currentSubPage = "pupilcorneadia";
          this.currentEye = "OS";
          this.pupilCorneaMode = this.isCheckItemDiagnosed(PAGES.pupilcorneadia, "OS")
            ? "pupilcorneadia"
            : this.isCheckItemDiagnosed("scotopia", "OS")
              ? "scotopia"
              : "dynamicpupil";
          this.menuItems = this.procMenus(this.checkType, this.currentRecord);
          this.currentPage = PAGES.topography;
          this.hideWaiting();
        } else {
          this.hideWaiting();
          this.currentSubPage = _checkItem;
          this.showCapture(this.checkType, this.currentSubPage);
        }
      } else {
        try {
          this.currentEye = eyetype;
          if (subpage === TOPOGRAPHYMODES.pupilcorneadia.key) {
            this.currentSubPage = subpage;
          } else {
            this.currentSubPage = "largemap";
            this.casePath = await topographyRecordProc.getRecord(this.currentRecord, eyetype);
          }
          this.currentPage = PAGES.topography;
          this.menuItems = this.procMenus(this.checkType, this.currentRecord);
          this.hideWaiting();
        } catch (e) {
          this.hideWaiting();
          this.currentSubPage = _checkItem;
          this.showCapture(this.checkType, subpage);
        }
      }
    },
    questionnaireExists() {
      return (
        isDefined(this.currentRecord) &&
        isDefined(this.currentRecord.content) &&
        isDefined(this.currentRecord.content.userQuestionnaire)
      );
    },
    getBatchNo() {
      let now = parseInt(Date.now() / 1000);
      let start = parseInt(new Date("1970-01-01").valueOf() / 1000);
      return now - start;
    },
    enterQN(cb) {
      if (!this.currentPatient) {
        let result = false;
        cb(result);
        return;
      }
      let cloneRecord = {
        patientid: this.currentPatient._id,
        checktype: "dryeye",
        content: {
          dataOD: {
            batchNo: this.getBatchNo(),
            diagnosed: false
          },
          dataOS: {
            batchNo: this.getBatchNo(),
            diagnosed: false
          },
          userQuestionnaire: {
            Speed: [],
            DEQ: [],
            McMonnies: [],
            OSDI: [],
            DryEyeMain: [],
            diagnosed: false
          }
        }
      };
      record.addRecord(cloneRecord, (res) => {
        this.currentRecord = res.record;

        this.hideWaiting();
        if (isFunction(cb)) {
          cb(this.currentRecord);
        }
      });
    },
    enterRecord(rec, subpage, eyetype) {
      let _id = rec._id;
      this.showWaiting();
      // /
      record.getRecordContent(_id, async (data) => {
        if (data.message === "OK") {
          this.currentRecord = data.record;
          this.checkType = this.currentRecord.checktype;

          if (this.checkType === PAGES.dryeye) {
            this.enterDryEye(subpage, eyetype);
          } else {
            await this.enterTopography(subpage, eyetype);
          }
        } else {
          procHttpDataError(this, data, this.$t("langcfg.txtFailToGetRecord"));
          this.hideWaiting();
        }
      });
    },
    showWaiting(text, time, forever = false) {
      this.waittingText = text || this.$t("langcfg.txtLoading");
      if (time) {
        timeoutWaitting = setTimeout(() => {
          this.isWaittingVisible = true;
        }, time);
      } else {
        this.isWaittingVisible = true;
      }
      if (forever) return;
      clearTimeout(timerHideWaiting);
      timerHideWaiting = setTimeout(() => {
        this.isWaittingVisible = false;
      }, 10 * 1000);
    },
    hideWaiting() {
      clearTimeout(timerHideWaiting);
      clearTimeout(timeoutWaitting);
      this.waittingText = "";
      this.isWaittingVisible = false;
      this.sendChangeSelectStatus();
    },
    // 先放入created 接收副屏（dist下面的index2.html）的值，接收名称可在服务端设置
    // 首页增删改同步
    sendChangeStatus() {
      // 这里传值，在副屏可接收值，但需要在serve端中转
      this.sendSetMsgType = "reloadMainFace";
      this.sendChangeStatusDetails();
    },
    // 发送增删改同步
    sendChangeStatusDetails() {
      let send = null;
      if (this.isHasUrl) {
        send = "sendSetMsg2";
      } else {
        send = "sendSetMsg";
      }
      ipcRenderer.send(send, {
        // 类型:刷新
        type: this.sendSetMsgType
      });
    },
    // 发送角膜
    sendChangeSelectStatus() {
      this.sendSetMsgType = "sendChangeSelectStatus";
      let send = null;
      if (this.isHasUrl) {
        send = "sendSetMsg2";
      } else {
        send = "sendSetMsg";
      }
      ipcRenderer.send(send, {
        type: this.sendSetMsgType,
        currentPatient: this.currentPatient
      });
    },
    event(e) {
      // if (e.keyCode === 13) {
      //   this.keyboardState = false
      //   fileSys.killallExe('onboard')
      //   if (_inputCallback) _inputCallback(this.currentInput)
      // }
      this.hideScreenSaver();
      return false;
    }
  },
  watch: {
    cameraInited(val) {
      if (val === false) {
        this.hideWaiting();
        this.message(this.$t("langcfg.txtCameraInitError"), "error");
      } else if (val === true) {
        this.hideWaiting();
        this.captureCallback && this.captureCallback();
      }
    },
    currentPatient(patient) {
      if (isDefined(patient)) {
        fileSys.writeFileSync(
          fileSys.getTmpFilePath("patient.json"),
          json2string({ patient: patient, page: this.patientPage })
        );
      }
    },
    patientPage(page) {
      if (isDefined(page)) {
        fileSys.writeFileSync(
          fileSys.getTmpFilePath("patient.json"),
          json2string({ patient: this.currentPatient, page: page })
        );
      }
    },
    currentPage(val) {
      this.saveScreen();
      if (val === PAGES.capture) {
        this.focusLanguage = window.settings.language;
      }
    },
    currentSubPage: function () {
      this.saveScreen();
    },
    isSettingsVisible: function () {
      if (this.isSettingsVisible) {
        this.$bus.$emit(EVENTS.showSettings);
        this.$bus.$emit(EVENTS.showOPI);
      }
      if (
        this.isSettingsVisible ||
        this.currentPage === PAGES.capture ||
        this.currentPage === PAGES.questionnaire
      )
        return;
      this.records = [];
      this.patientHeaders = patient.initHeaders();
      this.searchPatients(_search, undefined, () => {
        if (isDefined(this.currentPatient)) {
          this.getRecords(this.currentPatient._id, () => {
            this.$forceUpdate();
          });
        }
      });
    }
    // keyboardState: function (value) {
    //   if (value) {
    //     setTimeout(() => {
    //       document.getElementById('lockInput').focus()
    //     }, 100);
    //   }
    // }
  },
  mounted() {
    wpaWIfi.scanWifi();

    this.$bus.$on("ENTERRECORD", (rec, subpage, eyetype) => {
      // this.isPatientManagerVisible = true
      console.log("---cknb--- eyetype", eyetype);

      this.enterRecord(rec, subpage, eyetype);
    });

    this.$bus.$on("BACKTOPATIRNT", () => {
      // this.isPatientManagerVisible = true
      this.back2PatientManager();
    });

    this.$bus.$on(EVENTS.spreadKeyBoard, (input, callback) => {
      // setTimeout(() => {
      //   this.keyboardState = true
      // }, 600);
      this.spreadKeyBoard(input, callback);
    });
    this.$bus.$on(EVENTS.hideScreenSaver, () => {
      this.hideScreenSaver();
    });
    this.$bus.$on("thirdparty-enabled", (enabled) => {
      if (enabled) {
        this.startThirdPartyDownloadPatient();
      } else {
        this.stopThirdPartyDownloadPatient();
      }
    });
    this.startThirdPartyDownloadPatient();
    // 软键盘监听
    window.addEventListener("message", (evt) => {
      if (evt.data.init) {
        setTimeout(() => {
          this.isKeyboardLoading = false;
          this.hideWaiting();
        }, 800);
      } else if (isFunction(_inputCallback)) {
        if (evt.data.state) _inputCallback(evt.data.msg);
        _inputCallback = null;
        this.dialogVisible = false;
      }
    });
    // window.addEventListener('click', evt => {
    //   let div = document.querySelector('.keyboard')
    //   if (event.target !== div && !div.contains(event.target)) {
    //     // div.style.display = 'none'; // 如果点击的不是div本身或其子元素，则隐藏div
    //     this.keyboardState = false
    //     fileSys.killallExe('onboard')
    //     if (_inputCallback) _inputCallback(this.currentInput)
    //   }
    // })

    this.$bus.$on(EVENTS.showGlobalWatting, (text, time, forever) => {
      this.showWaiting(text, time, forever);
    });
    this.$bus.$on(EVENTS.hideGlobalWatting, () => {
      this.hideWaiting();
    });
    this.$bus.$on(EVENTS.refreshPatients, () => {
      this.records = [];
      this.patientPage = 1;
      this.searchPatients(_search);
    });
    this.$bus.$on(EVENTS.canLogout, (state) => {
      this.hideScreenSaver();
      this.canLogout = state;
    });
    this.$bus.$on(EVENTS.updateData, (newRecord, photo, marking, callback) => {
      this.currentRecord = newRecord;
      record.updateRecord(this.currentRecord, (res) => {
        if (photo) {
          updateMarking(photo.filename, marking, (res) => {
            if (callback && typeof callback === "function") {
              callback();
            }
          });
        } else {
          callback();
        }
      });
      this.menuItems = this.procMenus(this.checkType, this.currentRecord);
    });
    this.$bus.$on(EVENTS.reanalyzeMeibomian, (orgPhoto, data, upDown, marking, callback) => {
      dryeyeRecordProc.init(
        this.currentPatient,
        this.currentRecord,
        orgPhoto,
        this.currentEye,
        "meibomian",
        ""
      );
      dryeyeRecordProc.reAnalyzeMeibomian(
        orgPhoto,
        data,
        "meibomian",
        upDown,
        (result, newRecord) => {
          record.updateRecord(newRecord, (res) => {
            updateMarking(orgPhoto.filename, marking, (res) => {
              if (callback && typeof callback === "function") {
                callback(result, newRecord);
              }
            });
          });
        }
      );
    });
    this.$bus.$on(EVENTS.dryeyeUpDown, (state) => {
      this.nextState = state;
    });
    this.$bus.$on("CHANGECURRENTRECORD", (newRecord) => {
      this.currentRecord = objectCopy(newRecord);
    });
    this.$bus.$on("show-export", () => {
      this.showExportAllData = true;
    });
    this.$bus.$on("refresh-patients", () => {
      this.loginSuccess();
    });
    this.$bus.$on("update-menu", () => {
      this.menuItems = this.procMenus("dryeye", this.currentRecord, false);
    });
    this.eyeTypeRecognise();
    if (!window.__main__.debug) {
      if (fileSys.isFileExists("/home/mw520/dea520/count.txt")) {
        fileSys.deleteFile("/home/mw520/dea520/count.txt");
      }
    }
    this.saveScreen();
    // for (let id in cEvents) {
    //   document.addEventListener(cEvents[id], this.saveScreen)
    // }
    this.matchLanguage();
    fileSys.register("mountUsb", (data, drivers) => {
      this.hideScreenSaver();
      switch (data) {
        case "start":
          this.showWaiting(this.$t("langcfg.txtDiskIsBeingMounted"));
          break;
        case "end":
          this.hideWaiting();
          if (Object.keys(drivers).length > 0) {
            window.usbDriver = drivers;
            this.usbDriver = { status: true, ...drivers };
            this.message(this.$t("langcfg.txtDiskIsMounted"), "success", 2000);
          } else {
            if (fileSys.isUDiskExits().status) {
              this.message(this.$t("langcfg.txtDiskIsMountedFailed"), "error", 4000);
            }
            this.usbDriver = { status: false };
            window.usbDriver = null;
          }
          break;
        case "umount":
          if (window.usbDriver) {
            window.usbDriver = null;
            this.usbDriver = { status: false };
            this.message(this.$t("langcfg.txtDiskIsUmounted"), "success", 3000);
          }
          break;
        default:
          break;
      }
    });
    for (let id in docEvents) {
      document.addEventListener(docEvents[id], this.event);
    }
    window.usbDriver = fileSys.findUsbDriver();
    this.usbDriver = {
      status: fileSys.isUDiskExits().status,
      ...window.usbDriver
    };
    if (!isDefined(nibutInfrared)) {
      window.captureSettings.SelectLight = true;
      saveCaptureSettings(window.captureSettings);
    }
    this.$bus.$on("exit-de", () => {
      this.currentSubPage = DRYEYEMODES.tearheight.key;
      this.selectSubPage(this.currentSubPage);
    });
  },
  computed: {
    ...mapGetters(["camera", "cameraInited"]),
    offset() {
      return window.copyScreen ? 55 : 0;
    },
    // this.dispH和this.dispW在 使用混入mixins, 定义位置：./mixins/index.js中的Size
    isMenuVisible() {
      return this.currentPage !== PAGES.patientmanager && this.currentPage !== PAGES.settings;
    },
    isReCaputreVisible() {
      return (
        this.currentPage !== PAGES.patientmanager &&
        !this.isSettingsVisible &&
        this.currentSubPage !== "report" &&
        this.currentSubPage !== PAGES.questionnaire
      );
    },
    mainHeight() {
      return this.dispH - this.headerHeight;
    },
    mainWidth() {
      return this.dispW;
    },
    isPatientManagerVisible() {
      this.patientHeaders = patient.initHeaders();
      return this.currentPage === PAGES.patientmanager && !isDefined(this.propCurrentPatient);
    },
    captureHeight() {
      return this.mainHeight - 65;
      // this.checkType === CHECKTYPES.dryeye ? this.mainHeight - 65 : this.mainHeight - 65
    },
    ...mapState({
      isHasUrl: (state) => home.state.isHasUrl
    })
  },
  beforeDestroy() {
    // this.$bus.$off(EVENTS.showGlobalWatting)
    // this.$bus.$off(EVENTS.hideGlobalWatting)
    // this.$bus.$off(EVENTS.setLang)
    // this.$bus.$off(EVENTS.setDateFrom)
    // this.$bus.$off(EVENTS.setLogin)
    // this.$bus.$off(EVENTS.setDicom)
  }
};
</script>

<style lang="less">
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
#app {
  position: absolute;
  width: 100%;
  overflow: hidden;
}

.global-waitting {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  top: 0px;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  .waitting-content {
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 10px;
    font-size: 25px;
    padding: 15px;
  }
  z-index: 2000;
}

.btn-retake-app {
  position: absolute;
  border-radius: 10px;
  width: 80px;
  height: 53px;
  top: 130px;
  left: 20px;
  z-index: 100;
  color: #fbfbfb;
  font-weight: 600;
  font-family: "Open Sans", sans-serif;
  font-size: 15px;
  text-align: center;
  font-weight: 600;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 10px;

  span {
    font-size: 80px;
    color: rgba(255, 255, 255, 0.5);
  }
}

.btns-containner {
  position: absolute;
  right: 2px;
  width: 200px;
  z-index: 90;
  text-align: right;
}

.btn-osod-app {
  width: 70px;
  height: 53px;
  color: #fbfbfb;
  font-weight: 600;
  font-family: "Open Sans", sans-serif;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);
  font-size: 15px;
  text-align: center;
  border-radius: 0px;

  span {
    font-size: 50px;
  }

  line-height: 53px;
  height: 53px;
}

.capture-font {
  font-size: 53px;
}

.btn-osod-app:hover {
  color: @btn-hover-color;
  background-color: transparent;

  span {
    color: @btn-hover-color;
  }
}

.btn-osod-app:active {
  background-color: transparent;
}

.patient-manager {
  position: absolute;
  display: flex;

  .wrapper-patient-record {
    width: 50%;
    position: relative;
  }

  .border-left {
    border-left: 1px solid gray;
  }
}

.export-userList {
  background: #2d3039;
  width: 100%;
  height: 100%;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  top: 0;
}

.export-all-data {
  background: #2d3039;
  width: 100%;
  height: 100%;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  top: 0;
}

//  111隐藏date底部
.el-date-table td {
  padding: 2px 0;
}
.el-date-table th {
  font-size: 20px;
}
.el-picker-panel__footer .el-button {
  font-size: 24px;
}

.el-input__icon {
  font-size: 30px;
}
.el-input--small .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.el-time-panel__btn {
  font-size: 18px;
}
// .el-picker-panel__footer {
//   display: none;
// }
.el-date-picker {
  height: 520px;
}
.el-time-spinner__item {
  font-size: 25px;
}
.el-time-panel {
  width: 250px;
}
.el-time-spinner__item {
  line-height: 40px;
  height: 40px;
}
.el-notification__content {
  text-align: left !important;
}
.keyboard-containner {
  z-index: 3000;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  position: absolute;
  width: 100%;
}
// .keyboard {
//   position: absolute;
//   top: 454px;
// }
// .keyboard-method {
//   display: flex;
// }
// .keyboard-method /deep/ .el-radio__label {
//   vertical-align: middle;
// }
// .keykoard-input {
//   width: 100vw;
//   margin-top: 20px;
//   display: flex;
// }
// .keykoard-input /deep/ .el-input__inner {
//   height: 78px;
//   font-size: -webkit-xxx-large;
// }
// .keykoard-input /deep/ .el-input__suffix {
//   width: 100px;
//   height: 78px;
//   border-radius: 4px;
// }
// .keykoard-input /deep/ .el-input__icon {
//   width: 100px;
//   height: 78px;
//   font-size: 40px;
//   line-height: 78px;
//   color: #000;
// }
// .btn {
//   width: 100px;
//   margin: 5px 8px;
//   display: flex;
//   color: white;
//   justify-content: center;
//   align-items: center;
//   background: #2f2f2f;
//   -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
//   border-bottom: 1px solid #b5b5b5;
//   border-radius: 5px;
//   box-shadow: 0 0 3px -1px rgb(0 0 0 / 30%);
//   box-sizing: border-box;
//   cursor: pointer;
//   padding: 5px;
//   -webkit-user-select: none;
//   height: 78px;
//   margin-top: 0px;
//   color: black;
//   font-size: 30px;
//   background: white;
// }

.view-result-btn:hover {
  p {
    color: hsla(0, 0%, 100%, 0.5);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue